import React from "react";
import { useI18n } from "../../i18n";
import { formatClock } from "../../utils/dates";
import Sheet from "./Sheet";
import { formatMoney } from "../utils/money";

/** Parked tickets waiting to be resumed. */
const HeldTicketsSheet = ({ open, onClose, tickets, currency, onResume, onDiscard }) => {
  const { t } = useI18n();

  const heldSince = (isoDate) => {
    const minutes = Math.round((Date.now() - new Date(isoDate).getTime()) / 60000);

    if (minutes < 1) return t("pos.held.justNow");
    if (minutes < 60) return t("pos.held.minAgo", { count: minutes });

    return formatClock(isoDate);
  };

  return (
    <Sheet
      open={open}
      onClose={onClose}
      title={t("pos.held.title")}
      subtitle={t("pos.held.subtitle")}
    >
      {tickets.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-14 text-center px-6">
          <span className="text-5xl mb-3">⏸</span>
          <p className="text-slate-300 font-semibold">{t("pos.held.nothing")}</p>
          <p className="text-slate-500 text-sm mt-1">{t("pos.held.nothingHint")}</p>
        </div>
      ) : (
        <ul>
          {tickets.map((ticket) => (
            <li
              key={ticket.id}
              className="flex items-center gap-3 px-4 py-3 border-b border-slate-800 last:border-0"
            >
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-white truncate">
                  {ticket.label || t("pos.held.ticket")}
                </p>
                <p className="text-xs text-slate-400 mt-0.5">
                  {t("common.items", { count: ticket.itemCount })} ·{" "}
                  {formatMoney(ticket.total, currency)} · {heldSince(ticket.heldAt)}
                </p>
              </div>
              <button
                type="button"
                onClick={() => onDiscard(ticket.id)}
                className="h-10 px-3 rounded-xl bg-slate-800 border border-slate-700 text-xs font-bold text-slate-300 hover:bg-red-600/80 hover:text-white transition-colors"
              >
                {t("pos.held.discard")}
              </button>
              <button
                type="button"
                onClick={() => onResume(ticket.id)}
                className="h-10 px-4 rounded-xl bg-primary-600 hover:bg-primary-500 text-white text-xs font-bold transition-colors"
              >
                {t("pos.held.resume")}
              </button>
            </li>
          ))}
        </ul>
      )}
    </Sheet>
  );
};

export default HeldTicketsSheet;
